<template>
    <div>
        <el-card class="search-form-card">

            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" class="common-input"></el-input>
                    <el-button type="primary" @click='requestQuery'>搜索</el-button>
                </el-form-item>
            </el-form>

        </el-card>

        <el-card>

            <div slot="header">

                <router-link  :to="{ path:'/serveBargainUpdata',query: { callback:request } }">
                    <el-button type="primary">新增</el-button>
                </router-link>

            </div>

            <el-table :data="tableData" v-loading='loading'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.pageSize===item">
                            {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column type="selection" width="55"></el-table-column>

                <el-table-column label="名称" prop="title"></el-table-column>

                <el-table-column label="描述" prop="description"></el-table-column>

                <el-table-column label="有效开始事件" prop="warrantyStartTime"></el-table-column>

                <el-table-column label="有效结束时间" prop="warrantyEndTime"></el-table-column>

                <el-table-column label="费用" prop="cost">
                    <template slot-scope="{ row }">
                        <span>{{row.cost}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="付款周期" prop="paymentCycle"></el-table-column>

                <el-table-column label="供应商" prop="supplier">
                    <template slot-scope='scope'>
                        {{scope.row.supplier.title}}
                    </template>
                </el-table-column>

                <el-table-column label="合同状态" prop="status">
                    <template slot-scope="{ row }">
                        {{ row.status | tableVal(contractStatus) }}
                    </template>
                </el-table-column>

                <el-table-column label="服务项" prop="toService">
                    <template slot-scope="scope">
                        <span v-for='(item, index) of scope.row.toService' :key='item.serialNumber'>
                            {{item.title}}{{scope.row.toService.length-1 === index?'':","}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="联系人" prop="otUser">
                    <template slot-scope="scope">
                        <span v-for='(item, index) of scope.row.otUser' :key='item.serialNumber'>
                            {{item.name}}{{scope.row.toService.length-1 === index?'':","}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="文档" prop="toDocument">
                    <template slot-scope="scope">
                        <span v-for='(item, index) of scope.row.toDocument' :key='item.serialNumber'>
                            {{item.title}}{{scope.row.toDocument.length-1 === index?'':","}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="更新日期" prop="updateTime"></el-table-column>

                <el-table-column label="操作" fixed="right" width='120px'>
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/serveBargainUpdata',
                                        query: { serialNumber:scope.row.serialNumber,type:'edit',callback:request }}">
                            <el-button type="text" >修改</el-button>
                        </router-link>
                        <router-link :to="{ path: '/serveBargainDetail',
                                        query: { serialNumber: scope.row.serialNumber}}">
                            <el-button type="text">详情</el-button>
                        </router-link>
                        <el-button
                         class="table-del-btn"
                         type="text"
                         v-w-role="'ITSM-0073'"
                         @click="deleteRole(scope.$index, tableData, scope.row.serialNumber)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页器 -->
            <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="form.pageIndex"
             :page-sizes="[10,20, 30, 40]"
             :page-size="form.pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination>

        </el-card>
    </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import services from '../serve.services'

export default {

    components: { Pagination },

    data() {
        return {
            total: 0,
            loading: true,
            tableData: [],
            form: {
                pageSize: 10,
                pageIndex: 1,
            },
            pageSizes: [10, 20, 30, 40],

        }
    },

    mounted() {
        this.request()
    },

    computed:{
        // 字典
        dictionary(){
            return this.$store.state.dictionary
        },

        // 状态
        contractStatus(){
            return this.dictionary.contract_status
        },
    },

    methods: {
        requestQuery(){
            this.form.pageIndex = 1;
            this.request();
        },
        // 请求数据
        request() {
            this.tableData = []
            //this.total = null
            this.loading = true
            services.contractList(this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = +res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // 删除数据
        deleteRole(index, rows, serialNumber) {
            this.$confirm('此操作将永久删除该合同, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                services.contractDelete({serialNumber})
                    .then(res => {
                        this.request()
                        this.$message.success('删除成功！')
                    })
                    .catch(err => this.$message.error(err.message))
            }).catch(() => this.$message.info('已取消删除'));
        },

        // 更新分页器页数
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val)
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1
            };
            this.request()
        },

        // 更新分页器页码
        handleCurrentChange(val){
            this.form.pageIndex = val
            this.request()
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
